


















import { Component, Mixins, Prop } from "vue-property-decorator"

// Mixin
import { BackgroundMixin, FontMixin, LayoutMixin, WidgetMixin } from "./mixins"

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue")
  }
})
export default class WPage extends Mixins(
  WidgetMixin,
  LayoutMixin,
  BackgroundMixin,
  FontMixin,
) {
  @Prop({ type: Boolean, default: false })
  fluid!: boolean;

  get computedStyles () {
    return {
      ...this.computedBackgroundStyles,
      ...this.computedFontStyles,
    }
  }

  mounted() {
    // Scroll to the top on page load
    window.scrollTo(0, 0);
  }
}
